import { render, staticRenderFns } from "./ReclamationsView.vue?vue&type=template&id=12ce5782&scoped=true&"
import script from "./ReclamationsView.vue?vue&type=script&lang=js&"
export * from "./ReclamationsView.vue?vue&type=script&lang=js&"
import style0 from "./ReclamationsView.vue?vue&type=style&index=0&id=12ce5782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce5782",
  null
  
)

export default component.exports